export const _init_exchange_based_conditions = () => {
	return [
		{
			id: 1,
			cond: 'energy_exchange',
			i18n: 'opt_energy_exchange',
			countries: [
				{
					title: 'country_austria',
					value: 'Austria',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_belgium',
					value: 'Belgium',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_bulgaria',
					value: 'Bulgaria',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_croatia',
					value: 'Croatia',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_czech_republic',
					value: 'Czech_Republic',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_denmark',
					value: 'Denmark',
					regions: [
						{ title: 'country_region_dk1', value: 'DK1' },
						{ title: 'country_region_dk2', value: 'DK2' },
					],
					character: 'EUR/MWh',
				},
				{
					title: 'country_estonia',
					value: 'Estonia',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_finland',
					value: 'Finland',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_france',
					value: 'France',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_germany',
					value: 'Germany',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_greece',
					value: 'Greece',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_hungary',
					value: 'Hungary',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_italy',
					value: 'Italy',
					regions: [
						{ title: 'country_region_calabria', value: 'Calabria' },
						{ title: 'country_region_centre_north', value: 'Centre-North' },
						{ title: 'country_region_centre_south', value: 'Centre-South' },
						{ title: 'country_region_north', value: 'North' },
						{ title: 'country_region_sacoac', value: 'SACOAC' },
						{ title: 'country_region_sacodc', value: 'SACODC' },
						{ title: 'country_region_sardinia', value: 'Sardinia' },
						{ title: 'country_region_sicily', value: 'Sicily' },
						{ title: 'country_region_south', value: 'South' },
					],
					character: 'EUR/MWh',
				},
				{
					title: 'country_latvia',
					value: 'Latvia',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_lithuania',
					value: 'Lithuania',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_montenegro',
					value: 'Montenegro',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_netherlands',
					value: 'Netherlands',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_norway',
					value: 'Norway',
					regions: [
						{ title: 'country_region_no1', value: 'NO1' },
						{ title: 'country_region_no2', value: 'NO2' },
						{ title: 'country_region_no2nsl', value: 'NO2NSL' },
						{ title: 'country_region_no3', value: 'NO3' },
						{ title: 'country_region_no4', value: 'NO4' },
					],
					character: 'EUR/MWh',
				},
				{
					title: 'country_poland',
					value: 'Poland',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_portugal',
					value: 'Portugal',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_romania',
					value: 'Romania',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_serbia',
					value: 'Serbia',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_slovakia',
					value: 'Slovakia',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_slovenia',
					value: 'Slovenia',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_spain',
					value: 'Spain',
					regions: [],
					character: 'EUR/MWh',
				},
				{
					title: 'country_sweden',
					value: 'Sweden',
					regions: [
						{ title: 'country_region_se1', value: 'SE1' },
						{ title: 'country_region_se2', value: 'SE2' },
						{ title: 'country_region_se3', value: 'SE3' },
						{ title: 'country_region_se4', value: 'SE4' },
					],

					character: 'EUR/MWh',
				},
				{
					title: 'country_switzerland',
					value: 'Switzerland',
					regions: [],
					character: 'EUR/MWh',
				},
			],
			ui_operators: ['less than', 'more than'],
			input: 0,
		},
	];
};
